<mat-toolbar color="primary">
    <span class="title-center">{{title}}</span>
</mat-toolbar>


<div class="cc-forms-container">

    <div class="filter">
        <mat-form-field>
            <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
        </mat-form-field>
    </div>

    <mat-table class="mat-elevation-z8" #table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="select">
            <mat-header-cell style="flex-grow: 1;" *matHeaderCellDef>
                <mat-checkbox (change)="$event ? masterToggle($event) : null" 
                [checked]="this.selectedAccDistData.length && isAllSelected()"
                 [indeterminate]="!isAllSelected() && this.selectedAccDistData.length > 0">
                </mat-checkbox>
            </mat-header-cell>
            <mat-cell style="flex-grow: 1;" *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()" 
                [(ngModel)]="row.isActive" (change)="$event ? projectChecked(row) : null">
                </mat-checkbox>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="code">
            <mat-header-cell style="flex-grow: 1;" *matHeaderCellDef mat-sort-header> Code </mat-header-cell>
            <mat-cell style="flex-grow: 1;" *matCellDef="let row"> {{row.code}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="description">
            <mat-header-cell style="flex-grow: 5;" *matHeaderCellDef mat-sort-header> Description </mat-header-cell>
            <mat-cell style="flex-grow: 5;" *matCellDef="let row"> {{row.descr}} </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    <mat-card fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="center center">
        <button mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
        <button mat-raised-button (click)="onSave()" color="primary">Save</button>
    </mat-card>
</div>